import { styled } from '@mui/material/styles';
import {
  Fab,
} from '@mui/material';
import config from '../../../../../config/config';

const { PREFIX_CALENDAR } = config;

const PREFIX = PREFIX_CALENDAR;

export const classes = {
  addButton: `${PREFIX}-addButton`,
  content: `${PREFIX}-content`,
  contentContainer: `${PREFIX}-contentContainer`,
  text: `${PREFIX}-text`,
  title: `${PREFIX}-title`,
  icon: `${PREFIX}-icon`,
  contentItemIcon: `${PREFIX}-contentItemIcon`,
  grayIcon: `${PREFIX}-grayIcon`,
  colorfulContent: `${PREFIX}-colorfulContent`,
  lens: `${PREFIX}-lens`,
  textCenter: `${PREFIX}-textCenter`,
  dateAndTitle: `${PREFIX}-dateAndTitle`,
  titleContainer: `${PREFIX}-titleContainer`,
  container: `${PREFIX}-container`,
  header: `${PREFIX}-header`,
  closeButton: `${PREFIX}-closeButton`,
  buttonGroup: `${PREFIX}-buttonGroup`,
  button: `${PREFIX}-button`,
  wrapper: `${PREFIX}-wrapper`,
  wrapperButtons: `${PREFIX}-wrapperButtons`,
  textField: `${PREFIX}-textField`,
};

export const StyledFab = styled(Fab)(({ theme }) => ({
  [`&.${classes.addButton}`]: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(4),
  },
}));

export const StyledAppointmentContent = styled('div')(({ theme }) => ({
  [`&.${classes.content}`]: {
    padding: 2,
  },
  [`& .${classes.titleContainer}`]: {
    paddingBottom: theme.spacing(2),
  },
  [`& .${classes.title}`]: {
    paddingLeft: 1,
    fontSize: 12,
    color: 'white',
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
  },
}));

export const StyledTooltipContent = styled('div')(({ theme: { spacing, typography, palette }, color = '#FEB100' }) => ({
  [`&.${classes.content}`]: {
    padding: spacing(3, 1),
    paddingTop: 0,
    backgroundColor: palette.background.paper,
    boxSizing: 'border-box',
    width: '400px',
  },
  [`& .${classes.contentContainer}`]: {
    paddingBottom: spacing(1.5),
  },
  [`& .${classes.text}`]: {
    ...typography.body2,
    display: 'inline-block',
  },
  [`& .${classes.title}`]: {
    fontSize: 24,
    color: palette.text.secondary,
    fontWeight: typography.fontWeightBold,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
  },
  [`& .${classes.icon}`]: {
    verticalAlign: 'middle',
  },
  [`& .${classes.contentItemIcon}`]: {
    textAlign: 'center',
  },
  [`& .${classes.grayIcon}`]: {
    color: palette.action.active,
  },
  [`.${classes.colorfulContent}`]: {
    color: color ? color[300] : 'primary',
  },
  [`& .${classes.lens}`]: {
    width: spacing(4.5),
    height: spacing(4.5),
    verticalAlign: 'super',
    color,
  },
  [`& .${classes.textCenter}`]: {
    textAlign: 'center',
  },
  [`& .${classes.dateAndTitle}`]: {
    lineHeight: 1.1,
  },
  [`& .${classes.titleContainer}`]: {
    paddingBottom: spacing(2),
  },
  [`& .${classes.container}`]: {
    paddingBottom: spacing(1.5),
  },
}));


export const StyledDiv = styled('div')(({ theme }) => ({
  [`& .${classes.icon}`]: {
    marginRight: theme.spacing(2),
  },
  [`& .${classes.header}`]: {
    overflow: 'hidden',
    paddingTop: theme.spacing(0.5),
  },
  [`& .${classes.textField}`]: {
    width: '100%',
  },
  [`& .${classes.content}`]: {
    padding: theme.spacing(2),
    paddingTop: 0,
  },
  [`& .${classes.closeButton}`]: {
    float: 'right',
  },
  [`& .${classes.wrapper}`]: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  [`& .${classes.buttonGroup}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(2),
  },
  [`& .${classes.wrapperButtons}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
}));

